// Reducer Redux pour les relevés d'index de compteurs
// Structure: { [dev_eui]: [array of readings] }

const initialState = {};

function indexReadingsReducer(state = initialState, action) {
  switch (action.type) {
    case "indexReadings/updateAll":
      // Met à jour tous les relevés d'index
      return action.payload;

    case "indexReadings/updateForDevice":
      // Met à jour les relevés pour un device spécifique
      // Payload: { dev_eui: string, readings: array }
      return {
        ...state,
        [action.payload.dev_eui]: action.payload.readings,
      };

    case "indexReadings/addReading":
      // Ajoute un nouveau relevé pour un device
      // Payload: { dev_eui: string, reading: object }
      const existingReadings = state[action.payload.dev_eui] || [];
      return {
        ...state,
        [action.payload.dev_eui]: [
          action.payload.reading,
          ...existingReadings,
        ],
      };

    case "indexReadings/updateReading":
      // Met à jour un relevé existant
      // Payload: { dev_eui: string, reading_id: number, updatedReading: object }
      const deviceReadings = state[action.payload.dev_eui] || [];
      return {
        ...state,
        [action.payload.dev_eui]: deviceReadings.map((reading) =>
          reading.id === action.payload.reading_id
            ? { ...reading, ...action.payload.updatedReading }
            : reading
        ),
      };

    case "indexReadings/deleteReading":
      // Supprime un relevé
      // Payload: { dev_eui: string, reading_id: number }
      const readings = state[action.payload.dev_eui] || [];
      return {
        ...state,
        [action.payload.dev_eui]: readings.filter(
          (reading) => reading.id !== action.payload.reading_id
        ),
      };

    case "indexReadings/clear":
      // Efface tous les relevés
      return initialState;

    default:
      return state;
  }
}

export default indexReadingsReducer;
